import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware  from "redux-saga";
import rootReducers from '../reducers';
import rootSagas from '../sagas';


const saga = createSagaMiddleware();
const store = createStore(rootReducers, applyMiddleware(saga))

saga.run(rootSagas);

export default store